import React, {useState} from 'react'
import {AudioRecorder, useAudioRecorder} from 'react-audio-voice-recorder';
import {AudioPlayer} from '../audio-player/audio-player';
import './voice-recorder.module.scss'

export const VoiceRecorder = ({onRecordingComplete, blob}) => {
	const [isRecorded, setIsRecorded] = useState(false)
	
	const recorderControls = useAudioRecorder(
    {
      noiseSuppression: false,
      echoCancellation: true,
    },
    (err) => console.table(err)
  );

  return (
    <>
			{blob ? <AudioPlayer fullWidth={true} file={blob} variant='recorder' remove={() => {
				onRecordingComplete(null)
			}}/> :
			<AudioRecorder
				onRecordingComplete={(f) => {
					if(isRecorded){
						onRecordingComplete(null)
						setIsRecorded(false)
					}else{
						onRecordingComplete(f)
						setIsRecorded(true)
					}
				}}
				recorderControls={recorderControls}
				showVisualizer={true}
			/> }
    </>
  );
}
